import { IQuizItem } from '../../types/quiz';

type Props = {
  item: IQuizItem;
  info?: boolean;
  chart?: boolean;
  email?: boolean;
};

export const QuestionImage = ({ item, info, chart, email }: Props) => {
  if (!item?.image) {
    return null;
  }
  if (info) {
    return (
      <img src={item.image} style={{ width: '100%', maxWidth: '290px' }} />
    );
  }
  if (chart) {
    return (
      <img src={item.image} style={{ width: '100%', maxWidth: '500px' }} />
    );
  }
  if (email) {
    return (
      <img src={item.image} style={{ width: '100%', maxWidth: '150px' }} />
    );
  }
  return <img src={item.image} style={{ width: '100%', maxWidth: '220px' }} />;
};
